import * as S from './styles'
import { useContext } from 'react'
import { MainContext } from '../../../context/MainContext/MainContext'
import { SelectGrowth, Welcome } from '../../Molecules'
import MenuIcon from '@mui/icons-material/Menu'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import logo from '../../../assets/logo.png'
import ModalGrowth from '../../Molecules/ModalGrowth/modalGrowth'
import NewGrowth from '../../Molecules/NewGrowth/newGrowth'
import DefEx from '../../Molecules/DefEx/defEx'
import InitialPage from '../../Molecules/InitialPage/initialPage'

const Header = () => {
  const { login, showMenu, setShowMenu } = useContext(MainContext)

  return (
    <S.HeaderStyled>
      <h1><a href='/'><img src={logo} alt='Grow App' /></a></h1>

      {
        login.isLoggedIn ? (
          <>
            <nav className={showMenu ? 'opened' : 'closed'}>
              <InitialPage />
              <SelectGrowth />
              <ModalGrowth />
              <NewGrowth />
              <DefEx />
              <Welcome />
            </nav>

            <S.MenuButtonStyled className={showMenu ? 'opened' : 'closed'} onClick={() => setShowMenu(!showMenu)}>
              {
                showMenu ? (
                  <ArrowForwardIosIcon />
                ) : (
                  <MenuIcon />
                )
              }
            </S.MenuButtonStyled>
          </>
        ) : (
          <></>
        )
      }
    </S.HeaderStyled>
  )
}

export default Header
